import gsap from 'gsap'

document.addEventListener('DOMContentLoaded', () => {
    const imageBlocks = document.querySelectorAll('[data-animate-intro="true"]')

    imageBlocks.forEach((block) => {
        const imageWrapper = block.querySelector('.c-image__inner')

        if (!imageWrapper) return

        const isDesktop = window.matchMedia('(min-width: 992px)').matches
        const isMobile = window.matchMedia('(max-width: 991px)').matches

        const tl = gsap.timeline({
            defaults: {
                ease: 'in-j',
                duration: 2.2,
            },
        })

        if (isDesktop) {
            tl.fromTo(
                imageWrapper,
                {
                    yPercent: 100,
                    y: '164px',          // 10.25rem → 164px
                    width: '732px',      // 45.75rem → 732px
                    height: 'calc(100dvh - 48px)', // 3rem → 48px
                },
                {
                    yPercent: 0,
                    y: '-64px',          // 4rem → 64px
                    width: '100%',
                    height: 'calc(100dvh - 48px)', // 3rem → 48px
                }
            ).to(imageWrapper, {
                y: '0',
                height: '70dvh',
                duration: 1.5,
            })
        }

        if (isMobile) {
            tl.fromTo(
                imageWrapper,
                { y: '-32px' },       // 2rem → 32px
                { y: 0, height: '240px', duration: 1.5 } // 15rem → 240px
            )
        }

        // Reproduce automáticamente en carga inicial
        tl.play(0)
    })
})
